<template>

    <select v-model="handler" @change="change" class="form-control">
        <option value="auto">normal</option>
        <option value="contain">contain</option>
        <option value="cover">cover</option>
    </select>

</div>

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){

        this.$emit('change',this.handler);
    },
  }

}
</script>
